import styled from '@emotion/styled';


export const ImageContainer = styled.div`
    width:100%;
    aspect-ratio: 1 / 1;
    position: relative;
    border-radius: 10px;
    overflow: hidden;

    img{
        width:100%;
    }
`;

export const UserName = styled.span`
    position: absolute;
    bottom:0px;
    left:0;
    display: flex;
    align-items: center;
    justify-content: center;
    width:100%;
    background:#2A848E;
    color:#fff;
    font-size: 22px;
    padding:12px;
`;